import * as API from '@siloreal:shared:api';
import {
  buildSilobagListQuery,
  type SilobagListFilter,
} from '@siloreal:shared:api/service/silobag/silobag-list';

const SILOBAG_LIST_SUMMARY_ENDPOINT = '/v3/silobags/summary';

export type SilobagListSummaryServiceContract = {
  search?: string;
  filter?: SilobagListFilter;
  signal?: AbortSignal;
};

export async function listSilobagSummaryService(
  contract: SilobagListSummaryServiceContract = {}
): Promise<SilobagListSummaryResponse> {
  const query = buildSilobagListSummaryQuery(contract);
  const { data } = await API.http.fetch.get<SilobagListSummaryResponse>(SILOBAG_LIST_SUMMARY_ENDPOINT, {
    query,
    signal: contract.signal,
  });

  return data;
}

export function buildSilobagListSummaryQuery(contract: SilobagListSummaryServiceContract): string {
  return buildSilobagListQuery({
    search: contract.search,
    filter: contract.filter,
  });
}

export type SilobagListSummaryResponse = {
  totalFilteredSilobags: number;
  totalFilteredDiscrepancies: number;
  filteredRemainingStock: number;
  totalRemainingStock: number;
  filteredInputWeight?: number;
  filteredExtractedWeight?: number;
  totalInputWeight?: number;
  totalExtractedWeight?: number;
  web_silobags_count: number;
  web_silobags_stock?: number;
  insurance_silobags_count: number;
  insurance_silobags_stock: number;
  warrant_silobags_count: number;
  warrant_silobags_stock: number;
};
